import { MaskFuncs, PhoneMaskOpts } from './useMask.types';

export const currency: MaskFuncs = {
  getMaskedValue: (value) => {
    if (!value) return '';
    const [integers, decimals] = value.split('.');
    const integersLen = integers.length;
    let maskedValue = '';
    if (value.indexOf('.') !== -1) {
      if (!integers) {
        maskedValue = '0';
      }
      maskedValue += '.';
    }
    if (decimals) {
      maskedValue += decimals;
    }
    for (let i = integersLen - 1; i >= 2; i -= 3) {
      maskedValue =
        (i - 2 !== 0 ? ',' : '') + integers.slice(i - 2, i + 1) + maskedValue;
    }
    return `$${integers.slice(0, integersLen % 3)}${maskedValue}`;
  },
  reverseMaskedValue: (maskedValue) => {
    return maskedValue
      .replace(/[^\d.]/g, '')
      .replace(/^0+/, '')
      .replace(/,/g, '');
  },
};

export const phone: MaskFuncs = {
  getMaskedValue: (value, opts) => {
    const { prefix } = opts as PhoneMaskOpts;
    if (!value) return '';
    let maskedValue = `${prefix}${value.slice(0, 2)}`;
    for (let i = 2; i < value.length; i += 4) {
      maskedValue += ` ${value.slice(i, i + 4)}`;
    }
    return maskedValue;
  },
  reverseMaskedValue: (maskedValue, opts) => {
    const { prefix, length } = opts as PhoneMaskOpts;
    let value = maskedValue;
    if (prefix) {
      value = value.replace(prefix, '');
    }
    value = value.replace(/\D/g, '');
    if (length) {
      value = value.slice(0, length);
    }
    return value;
  },
};
